<script lang="ts">
	import { EditionsGalleryBrowse } from '../../components/EditionsGalleryBrowse';
	import { PageBody } from '#lib/features/navigation/components/PageBody/index.js';
	import { GlobalRoutes } from '#lib/features/navigation/constants/global-routes.js';
	import { Breadcrumbs } from '$global/components/Breadcrumbs';

	const dataCy = 'editions-gallery';

	const crumbs = [
		{ label: 'Home', href: GlobalRoutes.Home },
		{ label: 'Editions', href: GlobalRoutes.EditionsHome },
		{ label: 'Gallery' },
	];
</script>

<PageBody>
	<Breadcrumbs {dataCy} {crumbs} />

	<div class="mt-10 md:mt-16">
		<EditionsGalleryBrowse {dataCy} />
	</div>
</PageBody>
